





















import { Component, Prop, Vue, Watch } from "vue-property-decorator";
@Component
export default class ISwitch extends Vue {
  @Prop({
    type: String,
    default: "blue",
    required: false
  })
  trueColor!: string;
  @Prop({
    type: String,
    default: "#fff",
    required: false
  })
  falseColor!: string;
  @Prop({
    type: String,
    default: "gray",
    required: false
  })
  dotColor!: string;
  @Prop({
    type: Boolean,
    default: false,
    required: false
  })
  value!: boolean;
  @Prop({
    type: Array,
    default: () => [5, 3],
    required: false
  })
  size!: number[];
  @Prop({
    type: Number,
    default: 0.2,
    required: false
  })
  padding!: number;

  @Watch("value")
  watchValue(val: boolean) {
    this.onValueChange(val);
  }

  private isMouseDown: boolean = false;
  private isMouseEnter: boolean = false;
  private status: boolean = false;

  private switchBgColor: string = this.falseColor;
  private iSize = {
    width: this.size[0],
    height: this.size[1]
  };
  private dotSize = {
    height: this.size[1] - this.padding * 2,
    width: this.size[1] - this.padding * 2,
    AWitdh: this.size[1], //动画时，的宽度
    trueALeft: this.size[0] - this.padding - this.size[1], //为真时，动画时，左侧距离
    trueLeft: this.size[0] + this.padding - this.size[1] //为真时，左侧距离
  };
  private dotStyle = {
    top: this.padding + "vw",
    left: this.padding + "vw",
    width: this.dotSize.width + "vw",
    height: this.dotSize.height + "vw",
    background: this.dotColor,
    borderRadius: this.dotSize.height / 2 + "vw"
  };

  created() {
    this.onValueChange(this.value);
  }

  private onValueChange(value: boolean) {
    if (value) this.switchToTrue();
    else this.switchToFalse();
  }

  private switchToTrue() {
    this.status = true;
    this.dotStyle = {
      top: this.padding + "vw",
      left: this.dotSize.trueLeft + "vw",
      width: this.dotSize.width + "vw",
      height: this.dotSize.height + "vw",
      background: this.dotColor,
      borderRadius: this.dotSize.height / 2 + "vw"
    };
    this.switchBgColor = this.trueColor;
  }

  private switchToFalse() {
    this.status = false;
    this.dotStyle = {
      top: this.padding + "vw",
      left: this.padding + "vw",
      width: this.dotSize.width + "vw",
      height: this.dotSize.height + "vw",
      background: this.dotColor,
      borderRadius: this.dotSize.height / 2 + "vw"
    };
    this.switchBgColor = this.falseColor;
  }

  private mouseDown() {
    this.isMouseDown = true;
    if (this.status) {
      this.dotStyle = {
        top: this.padding + "vw",
        width: this.dotSize.AWitdh + "vw",
        left: this.dotSize.trueALeft + "vw",
        height: this.dotSize.height + "vw",
        background: this.dotColor,
        borderRadius: this.dotSize.height / 2 + "vw"
      };
    } else {
      this.dotStyle = {
        top: this.padding + "vw",
        left: this.padding + "vw",
        width: this.dotSize.AWitdh + "vw",
        height: this.dotSize.height + "vw",
        background: this.dotColor,
        borderRadius: this.dotSize.height / 2 + "vw"
      };
    }
  }
  private mouseEnter() {
    this.isMouseEnter = true;
  }
  private mouseLeave() {
    if (this.isMouseEnter && this.isMouseDown) {
      this.isMouseEnter = false;
      if (this.status) {
        this.dotStyle = {
          top: this.padding + "vw",
          left: this.dotSize.trueLeft + "vw",
          width: this.dotSize.width + "vw",
          height: this.dotSize.height + "vw",
          background: this.dotColor,
          borderRadius: this.dotSize.height / 2 + "vw"
        };
      } else {
        this.dotStyle = {
          top: this.padding + "vw",
          left: this.padding + "vw",
          width: this.dotSize.width + "vw",
          height: this.dotSize.height + "vw",
          background: this.dotColor,
          borderRadius: this.dotSize.height / 2 + "vw"
        };
      }
    }
  }
  private mouseUp() {
    if (this.isMouseDown) {
      this.isMouseDown = false;
      if (this.status) {
        this.switchToFalse();
      } else {
        this.switchToTrue();
      }
      this.$emit("on-change", this.status);
    }
  }
}
